import { baseDarkTheme } from '~base-theme';
import commerceTheme from './commerceTheme';
var commerceDarkTheme = {
  commerce: Object.assign({}, commerceTheme.commerce, {
    productTemplate: {
      bgStart: '#131313',
      bgEnd: '#131313'
    },
    adsBanner: {
      container: {
        border: baseDarkTheme.base.grays.grayLight
      }
    }
  })
};
export default commerceDarkTheme;